// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.InsuranceInvoiceTransferSplitRequest */
/* istanbul ignore next */
@GandalfModel
export class InsuranceInvoiceTransferSplitRequest extends GandalfModelBase {

	@GandalfLabel('Amount')
	@GandalfValidator({ moneyConstraints: { positiveAllowed: true, zeroAllowed: true, negativeAllowed: false, message: 'Amount cannot be negative' } })
	@GandalfProperty({ propertyType: 'Money', designType: Number })
	amount!: number | null;

	@GandalfLabel('Person Insurance')
	@GandalfProperty({ designType: Number })
	personInsuranceId!: number | null;

	@GandalfLabel('Practice Insurance Company')
	@GandalfProperty({ designType: Number })
	practiceInsuranceCompanyId!: number | null;

	@GandalfLabel('Reason')
	@GandalfValidator({ sizeString: { message: 'Reason cannot be longer than 255 characters', minLength: 0, maxLength: 255 } })
	@GandalfProperty({ designType: String })
	reason!: string | null;

	@GandalfLabel('Transfer Reason')
	@GandalfProperty({ designType: Number })
	reasonId!: number | null;

}
